import { RouterActionTypes, SET_ROUTE } from './types';

export const setRoute = (payload: string, params): RouterActionTypes => ({
  type: SET_ROUTE,
  payload,
  ...(params && { params }),
});
